import { uiText, useUiLanguage } from '@/i18n/interface';

import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

interface AttendanceRecord {
  id: string;
  attended: boolean;
  student: {
    first_name: string;
    last_name: string;
  };
}

interface AttendanceTableProps {
  attendanceRecords: AttendanceRecord[];
  isLoading: boolean;
}

const AttendanceTable: React.FC<AttendanceTableProps> = ({ attendanceRecords, isLoading }) => {
  useUiLanguage();
  if (isLoading) {
    return (
      <div className="text-center py-4 text-gray-500">{uiText("Loading attendance...")}</div>
    );
  }

  if (attendanceRecords.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500">{uiText("No confirmations yet")}</div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{uiText("Student Name")}</TableHead>
          <TableHead>{uiText("Status")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {attendanceRecords.map((record) => (
          <TableRow key={record.id}>
            <TableCell>
              {record.student.first_name} {record.student.last_name}
            </TableCell>
            <TableCell>
              <Badge variant={record.attended ? 'default' : 'secondary'}>
                {record.attended ? uiText("Will Attend") : uiText("Will Not Attend")}
              </Badge>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default AttendanceTable;
